<template>
  <div class="car-life">
    <div class="car-life-service__wrapper">
      <div
        class="car-life-service"
        v-for="(item, index) in services"
        :key="index"
        @click="jumpTo(item)"
      >
        <img class="icon" v-if="item.categoryName === '违章'" src="@/assets/img/ticket/parkingViolations.png" />
        <img class="icon" v-if="item.categoryName === '罚单'" src="@/assets/img/ticket/ticket.png" />
        <div>{{ item.categoryName }}缴费</div>
        <van-icon class="justify--end" name="arrow"></van-icon>
      </div>
    </div>
    <div class="text--bottom">
      <span @click="goOrderList">我的订单</span>
      <span class="line">|</span>
      <span @click="goCommonProblem">常见问题</span>
    </div>
  </div>
</template>

<script>
import { cookieSet } from "@/common/cookie";
import { queryDict,checkOldToken, carList, findProductList} from "@/common/api.js";
export default {
  name: "ticket",
  components: {
  },
  data() {
    return {
      services: [
        // {
        //   name: "罚单缴费",
        //   pic: require("@/assets/img/ticket/ticket.png"),
        //   path: "/ticketCheck", // TODO
        // },
        // {
        //   name: "违章缴费",
        //   pic: require("@/assets/img/ticket/parkingViolations.png"),
        //   path: "carCheck", // TODO
        // }
      ],
      carListData: []
    };
  },

  mounted() {
    this.init();
    this.findProductList()
  },

  methods: {
    async init(){
      // 处理从小程序入口跳转过来
      if (this.$route.query.token) {
        let token = this.$route.query.token;
        token = (token || "").replace(/\s/g, "+");

        const res = await checkOldToken({ token: token });
        if (!res) {
          this.$router.push({ path: "/" });
          return;
        }

        if (
          document.domain.indexOf("vas") > -1 ||
          document.domain.indexOf("zengzhi") > -1
        ) {
          cookieSet("token", token, {
            domain: window.location.hostname,
          });
        }
      }
    },
    async findProductList() {
      const data = {
        categoryCodeList: [this.$route.query.categoryCode],
        pageNum: 1,
        pageSize: 10,
      }
      const res = await findProductList(data)
      console.log(res.list);
      this.services = res.list
    },
    async getCarList() {
      const res = await carList({phone: this.$route.query.phone})
      this.carListData = res
    },
    async getServices(){
      const res = await queryDict({code:'H5_PRODUCT_DEFAULT',key: ''})
      if (!res) {
          this.$router.push({ path: "/" });
          return;
      }
      this.services = res.kvs;
    },
    async jumpTo(item) {
      let path = ''
      if(item.categoryName == '违章'){
        await this.getCarList()
        path = '/carCheck'
      } else {
        path = '/ticketCheck'
      }
      
      if (path) {
        this.$router.push({
          path: item.categoryName == '违章' && this.carListData.length > 0 ? '/parkingViolationsCheck' : path,
          query: {
            phone: this.$route.query.phone,
            categoryCode: item.categoryCode,
            productCode: item.productCode
          },
        });
      }
    },
    goOrderList() {
      this.$router.push({
        path: '/orderList',
      });
    },
    goCommonProblem() {
      this.$router.push({
        path: '/commonProblem',
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.car-life {
  position: relative;
  background: #f4f6f7;
  min-height: 100vh;
  overflow-y: scroll;

  &-service {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 0.4rem;
    width: 7.02rem;
    height: 1.92rem;
    border-radius: 0.16rem;
    background: #fff;
    margin: 0.24rem auto;

    &__wrapper {
      min-height: calc(100vh - 1.4rem);
    }

    .icon {
      width: 1.2rem;
      height: 1.2rem;
      margin: 0 0.32rem;
    }

    .justify--end {
      font-size: 0.3rem;
      flex: 1;
      text-align: right;
      display: inline-block;
      margin-right: 0.52rem;
    }
  }

  .text--bottom {
    font-size: 0.32rem;
    width: 100vw;
    text-align: center;
    color: #5986B3;
    margin: 0.4rem auto;
    .line{
      margin: 0 0.1rem;
    }
  }
}
</style>

